export default __webpack_public_path__ + "static/media/Artboard 2@3x.80452710.png";